import 'autotrack';

import './adLoader';
import './dropdown';

// const primaryToggles = document.querySelectorAll('.seat__election--primary');
// const numPrimaryToggles = primaryToggles.length;
//
// for (let i = 0; i < numPrimaryToggles; i++) {
//   const toggle = primaryToggles[i];
//
//   toggle.addEventListener('click', () => {
//     toggle.classList.toggle('js-viewable-races');
//   });
// }



/** WEBPACK FOOTER **
 ** ./main.js
 **/